import { fillLayers, matchColor, OTHER, pick, type LayerStyle } from "./types";

// Grouped by base district, the way the zoning map legend groups them.
const RESIDENTIAL = "#ae6f0d";
const MULTIFAMILY = "#c0504d";
const COMMERCIAL = "#d0457f";
const OFFICE = "#8e6bd6";
const INDUSTRIAL = "#8b7a6a";
const MIXED = "#2c85b1";
const PUBLIC = "#3b8f4e";

const color = matchColor("ZONING_BASE", [
  [["RR", "LA", "SF", "MH"], RESIDENTIAL],
  [["MF"], MULTIFAMILY],
  [["LR", "GR", "CR", "CS", "CH", "L", "W/LO"], COMMERCIAL],
  [["NO", "LO", "GO"], OFFICE],
  [["IP", "LI", "MI", "R&D"], INDUSTRIAL],
  [["CBD", "DMU", "ERC", "NBG", "PUD", "TND", "TOD"], MIXED],
  [["P", "AV", "AG", "DR", "UNZ"], PUBLIC],
]);

const style: LayerStyle = {
  id: "coa-zoning",
  minzoom: 11,
  maxzoom: 15,
  layers(source) {
    return fillLayers(this, source, color, 0.25);
  },
  legend: [
    { label: "Single-family and rural residential (SF, RR, LA, MH)", color: RESIDENTIAL },
    { label: "Multifamily (MF)", color: MULTIFAMILY },
    { label: "Commercial (LR, GR, CR, CS, CH)", color: COMMERCIAL },
    { label: "Office (NO, LO, GO)", color: OFFICE },
    { label: "Industrial (IP, LI, MI)", color: INDUSTRIAL },
    { label: "Downtown, mixed and planned (CBD, DMU, PUD, TOD…)", color: MIXED },
    { label: "Public, aviation, agricultural, reserve (P, AV, AG, DR)", color: PUBLIC },
    { label: "Other", color: OTHER },
  ],
  describe: (p) =>
    pick(p, [
      ["ZONING_ZTYPE", "Zoning"],
      ["ZONING_BASE", "Base district"],
    ]),
};

export default style;
